// ------------- import external dependencies ----------------
import styled from "styled-components";

export const Heading = styled.h1`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  color: var(--text_primary);
`;

export const AssWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 1rem;
  @media screen and (min-width: 545px) {
    & > div {
      width: 200px;

      & > span {
        font-size: 0.8rem;
        font-family: Inter;
        font-weight: 500;
        display: block;
        color: var(--text_primary);
      }
    }
  }

  @media screen and (max-width: 545px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const ModalContent = styled.div``;
export const ColumnHeadingContainer = styled.div`
  @media screen and (max-width: 545px) {
    display: none;
  }
`;
export const MobileHeading = styled.h2`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  color: var(--text_primary);

  display: none;
  @media screen and (max-width: 545px) {
    display: block;
  }
`;

export const ColumnContainer = styled.div`
  @media screen and (max-width: 545px) {
    width: 100%;
  }
`;
export const RowData = styled.span`
  @media screen and (max-width: 545px) {
    width: 100%;
  }
`;
